<template>
    <div class="list">
        <div v-if="!carData || carData.length === 0" class="list-empty">暂无数据</div>
        <div
            v-for="(item, idx) in carData"
            :key="item.id || item.key"
            :class="{'list-title': item.keyName, 'list-info': !item.keyName}"
        >
            <div v-if="item.keyName" class="list-title">
                <p class="list-name">{{item.keyName}}</p>
                <p class="list-price-fact">厂商指导价</p>
                <p class="list-price-seller">经销商报价</p>
                <p class="list-operator">操作</p>
            </div>
            <template v-else>
                <p class="list-name">
                    <router-link
                        :to="{
                            name: 'CAR_INFO',
                            query: {
                                seriesName: carSeriesInfo.name
                            },
                            params: {
                                serid: carSeriesInfo.id,
                                modelId: item.id
                            }
                        }"
                        target="_blank"
                        @click.native="logCarInfo(item, idx)"
                    >
                        {{item.modelName}}
                    </router-link>
                </p>
                <p class="list-price-fact">{{item.manufacturerPrice}}</p>
                <p class="list-price-seller">
                    <span class="real-price">{{item.referencePrice}}</span>
                    <router-link
                        v-if="item.modelAskPriceWiseUrl"
                        :to="{
                            name: 'ASK_PRICE',
                            query: {
                                modelId: item.id,
                                fromPage: `${$route.path}@car_train_askPrice_click@${tabpane}@${idx}`
                            },
                            params: {
                                serid: carSeriesInfo.id
                            }
                        }"
                        class="list-btn btn-askprice"
                        target="_blank"
                        :data-key="'carlist_' + carSeriesInfo.id + '_' + item.id"
                        :data-modelName="item.modelName"
                        :data-modelId="item.id"
                        :data-pos="idx"
                        @click.native="logAskPrice(item, idx)"
                    >获取底价</router-link>
                </p>
                <p class="list-operator">
                    <router-link
                        v-if="+item.has_model_config"
                        :to="{
                            name: 'PARAMETER',
                            params: {
                                serid: carSeriesInfo.id,
                                modelId: item.id
                            }
                        }"
                        class="list-btn"
                        target="_blank"
                        @click.native="logParams(item, idx)"
                    >参数</router-link>
                    <span
                        v-else
                        class="list-btn list-btn-disabled"
                    >参数</span>
                    <template>
                        <span
                            v-if="!contrastList.find(v => v.id === item.id)"
                            class="list-btn btn-contrast"
                            @click="handleAddContrast(item, idx)"
                        >加对比</span>
                        <span
                            v-else
                            class="list-btn btn-contrast list-btn-disabled"
                            @click="handleDelContrast(item)"
                        >已添加</span>
                    </template>
                </p>
            </template>
        </div>
    </div>
</template>

<script>
/**
 * @file
 * @author guozhihao02
 */
import {sendLog} from 'js/log';
import {setModel, delModel} from 'js/dataParse';

export default {
    data() {
        return {

        };
    },
    props: {
        carData: {
            'type': Array,
            'default': [],
            'required': true
        },
        carSeriesInfo: Object,
        contrastList: {
            type: Array,
            default: () => []
        },
        tabpane: String
    },
    methods: {
        handleAddContrast(item, pos) {
            this.$emit('addcontrast', {
                modelName: `${this.carSeriesInfo.name} ${item.modelName}`,
                id: item.id
            });
            setModel(item.id, `${this.carSeriesInfo.name} ${item.modelName}`);
            this.sendLog('add_model_click', {
                modelId: item.id,
                pos
            });
        },
        handleDelContrast(item) {
            this.$emit('addcontrast', item, 'del');
            delModel(item.id);
            this.sendLog('del_model_click', {
                modelId: item.id
            });
        },
        logAskPrice(item, pos) {
            /* eslint-disable fecs-camelcase */
            this.sendLog('askPrice_click', {
                modelId: item.id,
                pos,
                price_url: item.modelAskPriceWiseUrl
            });
            this.$emit('sendUbcLog', 'clue_form', {ext: {area: 'car_train_askPrice_click'}});
            /* eslint-enable fecs-camelcase */
        },
        logParams(item, pos) {
            this.sendLog('paramter_click', {
                modelId: item.id,
                pos
            });
        },
        logCarInfo(item, pos) {
            this.sendLog('model_click', {
                modelId: item.id,
                pos
            });
        },
        sendLog(key, params) {
            // this.$parent.sendLog(key, params);
            this.$emit('sendlog', key, params);
        }
    }
};
</script>

<style lang="less" scoped>
@themeColor: #00CECF;

.list {
    font-size: 16px;
    .list-empty {
        text-align: center;
        margin-top: 100px;
    }
    .list-title,
    .list-info {
        display: flex;
        height: 52px;
        line-height: 52px;
        cursor: default;
        > p {
            box-sizing: border-box;
            padding-right: 12px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
    .list-title {
        position: relative;
        color: #666666;
        background: #F8F8F8;
        margin-top: -1px;
        .list-name {
            color: #333333;
        }
    }
    .list-info {
        color: #333333;
        border-bottom: 1px solid #E6E6E6;
        .list-price-seller {
            color: #FF6F61;
        }
    }
    .list-name {
        width: 401px;
        padding-left: 12px;
        a {
            color: #333333;
            user-select: text;
        }
    }
    .list-price-fact {
        width: 261px;
    }
    .list-price-seller {
        width: 272px;
        > span {
            display: inline-block;
            min-width: 82px;
            margin-right: 6px;
        }
        .list-btn {
            display: inline-block;
            width: 80px;
            font-size: 14px;
            text-align: center;
            line-height: 26px;
            height: 26px;
            border: 1px solid @themeColor;
            border-radius: 3px;
            outline: none;
            color: @themeColor;
            cursor: pointer;
        }
    }
    .list-operator {
        width: 266px;
        .list-btn {
            display: inline-block;
            width: 72px;
            font-size: 14px;
            text-align: center;
            line-height: 26px;
            height: 26px;
            // border: 1px solid @themeColor;
            border: 1px solid #D6D6D6;
            border-radius: 3px;
            outline: none;
            color: #333333;
            cursor: pointer;
            &.list-btn-disabled {
                border: 1px solid #D6D6D6;
                color: #999999;
            }
            &.btn-contrast {
                margin-left: 16px;
            }
        }
    }
}
</style>
